/*
  Primal Viking · EA Hero countdown (pv-ea-hero.js)
  Two modes, from [data-pv-eah-countdown][data-mode]:

  - daily (default, Figma note on 113:5533): counts 24h -> 0 to the next
    midnight in [data-tz] (IANA name, default Europe/Berlin = 00:00 CET, 6pm ET) and restarts.
    The wall clock is read with Intl in that timezone, so every visitor sees
    the same remaining time and DST days need no special casing.
  - fixed: counts down to [data-end] (ISO 8601 with UTC offset, e.g.
    2026-11-27T23:59:59-05:00) and stops at 00:00:00. Hours are total hours
    (no days box), so 3+ digits are possible more than 99 hours out. A value
    without an offset is rejected (it would be read in each visitor's local
    time) and the timer stays at 00:00:00 with a console warning.

  Once it reaches zero the countdown gets data-expired="true" (hook for
  styling). Scoped to each section root, idempotent via dataset.ready,
  re-initialised on shopify:section:load and stopped on section:unload.
*/
(function () {
  if (window.PVEaHero) return;

  var OFFSET_RE = /(Z|[+-]\d{2}:?\d{2})$/i;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseEnd(raw) {
    var v = (raw || '').trim();
    if (!v) return NaN;
    v = v.replace(' ', 'T').replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    if (!OFFSET_RE.test(v)) {
      console.warn('[pv-ea-hero] "Sale ends at" needs a UTC offset, e.g. 2026-11-27T23:59:59-05:00. Got: ' + raw);
      return NaN;
    }
    return Date.parse(v);
  }

  var DEFAULT_TZ = 'Europe/Berlin';
  var clockCache = {};

  function wallClock(tz) {
    if (!clockCache[tz]) {
      try {
        clockCache[tz] = new Intl.DateTimeFormat('en-US', {
          timeZone: tz, hourCycle: 'h23', hour: '2-digit', minute: '2-digit', second: '2-digit'
        });
      } catch (e) {
        console.warn('[pv-ea-hero] Unknown timezone "' + tz + '", using ' + DEFAULT_TZ);
        clockCache[tz] = wallClock(DEFAULT_TZ);
      }
    }
    return clockCache[tz];
  }

  // Seconds until the next midnight in tz (86400 right at midnight).
  function secondsToMidnight(tz) {
    var t = {};
    wallClock(tz).formatToParts(new Date()).forEach(function (p) { t[p.type] = Number(p.value); });
    return 86400 - (((t.hour % 24) * 3600) + (t.minute * 60) + t.second);
  }

  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var cd = root.querySelector('[data-pv-eah-countdown]');
    if (!cd) return;

    var hEl = cd.querySelector('[data-pv-eah-hours]');
    var mEl = cd.querySelector('[data-pv-eah-minutes]');
    var sEl = cd.querySelector('[data-pv-eah-seconds]');
    var daily = cd.getAttribute('data-mode') !== 'fixed';
    var tz = (cd.getAttribute('data-tz') || '').trim() || DEFAULT_TZ;
    var end = daily ? NaN : parseEnd(cd.getAttribute('data-end'));
    var timer = null;

    function render() {
      var ms, left;
      if (daily) {
        left = secondsToMidnight(tz);
        ms = 1000 - (Date.now() % 1000);
      } else {
        ms = isNaN(end) ? 0 : end - Date.now();
        left = ms > 0 ? Math.ceil(ms / 1000) : 0;
      }

      if (hEl) hEl.textContent = pad(Math.floor(left / 3600));
      if (mEl) mEl.textContent = pad(Math.floor((left % 3600) / 60));
      if (sEl) sEl.textContent = pad(left % 60);

      if (!daily && left <= 0) {
        cd.dataset.expired = 'true';
        timer = null;
        return;
      }
      // Next tick right after the displayed second changes.
      timer = setTimeout(render, (ms % 1000 || 1000) + 20);
    }

    render();

    root._pvEahStop = function () {
      if (timer) clearTimeout(timer);
      timer = null;
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pv-eah]').forEach(init);
  }

  window.PVEaHero = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector('[data-pv-eah]');
    if (root && root._pvEahStop) root._pvEahStop();
  });
})();
